import { render } from "./DocumentClassTranslationsSubView.vue?vue&type=template&id=3538c06c&scoped=true&ts=true"
import script from "./DocumentClassTranslationsSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassTranslationsSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassTranslationsSubView.vue?vue&type=style&index=0&id=3538c06c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3538c06c"]])

export default __exports__